// @flow

import querystring from 'querystring';
// $FlowFixMe
import { getResId } from './helper';
import type { ProductsServiceParameterConfigs } from './types';

const appliedFacetParams = ({
  departmentId,
  facetQueryString,
  ignoreInventory,
}) => {
  const appliedFacetParams = {
    ...(departmentId ? { department: departmentId } : {}),
    ...querystring.parse(facetQueryString),
  };

  if (ignoreInventory) delete appliedFacetParams.storeId;

  return appliedFacetParams;
};

const getAbseg = (productsUrl, abSeg) =>
  productsUrl && abSeg ? JSON.stringify(abSeg) : '';

const buildPdsUrl = ({
  cid,
  departmentId,
  pageId,
  facetQueryString,
  productsUrl,
  abSeg,
  previewState,
  isFlexFacetsEnabled,
  locale,
  ignoreInventory,
}: ProductsServiceParameterConfigs) => {
  const {
    pgAT,
    pgBR,
    pgGP,
    pgON,
    pgGPFS,
    pgBRFS,
    pgATCA,
    pgBRCA,
    pgGPCA,
    pgONCA,
  } = abSeg || {};

  const parameters = {
    ...previewState,
    resId: getResId(productsUrl),
    abSeg: getAbseg(productsUrl, {
      pgAT,
      pgBR,
      pgGP,
      pgON,
      pgGPFS,
      pgBRFS,
      pgATCA,
      pgBRCA,
      pgGPCA,
      pgONCA,
    }),
    cid,
    pageId,
    isFacetsEnabled: 'true',
    globalShippingCountryCode: 'us',
    globalShippingCurrencyCode: 'USD',
    locale,
    ignoreInventory,
    ...(isFlexFacetsEnabled ? { newContract: true } : null),
    // Product data and facets arent showing up with the department included in the v1 PDS API request URL
    ...appliedFacetParams({ departmentId, facetQueryString, ignoreInventory }),
  };

  return `${productsUrl}?${querystring.stringify(parameters)}`;
};

export default buildPdsUrl;
